import { BASE_URL,  NOTIFICATIONS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { INotification } from "models/notifications";

export async function getNotifications(params: string = "") : Promise<INotification[]> {
  const response = await axios.get(BASE_URL + NOTIFICATIONS + params);
  return response.data;
}


export async function readNotifications(params: string = "")  {
  const response = await axios.post(BASE_URL + NOTIFICATIONS + '/markasRead' + params);
  return response.data;
}


export const NotificationsCells: HeadCell[] = [
  {
    id: "clientName",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "notificationDate",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },
  {
    id: "countryCode",
    numeric: false,
    disablePadding: false,
    label: "Country Code",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
  },
  {
    id: "message",
    numeric: false,
    disablePadding: false,
    label: "Message",
  },
   {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "Is Read",
  },
];
